import { useClassName } from '@/styles/Tag';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export interface TagProps extends ComponentProps<'span'> {
  colors?: ClassNameProp<'default' | 'text'>;
  size?: ClassNameProp<'small' | 'medium' | 'large' | 'text'>;
  variant?: ClassNameProp<'default' | 'text'>;
}

const TagComponent: Component<TagProps> = ({ children, ...props }) => {
  const className = useClassName('', props, {
    defaults: { size: 'medium' },
    fallbacks: { size: 'variant', colors: 'variant' },
  });

  return <span {...mergeProps({ className }, props)}>{children}</span>;
};

export const Tag = TagComponent;
